export default "/images/fc59dc4ab9dc3b052de09aced66c64df.avif";